import { mostrarIdioma } from "@/utils/utils.js";

export default {
  selectCocinas(state){
    var res = [];
    state.cocinasArray.forEach(e => {
      let aux = {
        value : e.id,
        text : mostrarIdioma(e.nombre)
      }
      res.push(aux);
    });
    return res;
  }
}